export function formatElapsedMinutes(value) {
  const minutes = Math.max(0, Math.floor(Number(value) || 0));

  if (minutes < 1) return "agora";
  if (minutes < 60) return `${minutes} min`;

  const hours = Math.floor(minutes / 60);
  const remainingMinutes = minutes % 60;

  if (hours < 24) {
    return remainingMinutes ? `${hours}h ${remainingMinutes}m` : `${hours}h`;
  }

  const days = Math.floor(hours / 24);
  const remainingHours = hours % 24;

  return remainingHours ? `${days}d ${remainingHours}h` : `${days}d`;
}

export function quantityLabel(value, singular, plural) {
  const quantity = Math.max(0, Number(value) || 0);
  return `${quantity} ${quantity === 1 ? singular : plural}`;
}
